import { useState, useEffect } from 'react';
import { UsersApi } from '@/api/clients/users/users.api';

export const useGetFacilityUserHistory = (userId, options = {}) => {
  const { autoFetch = true } = options;
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pagination, setPagination] = useState({
    page: 1,
    totalPages: 1,
    total: 0,
    limit: 50,
  });

  const fetchUserHistory = async (page = 1, limit = 50) => {
    if (!userId) {
      setError('User ID is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await UsersApi.getFacilityUserHistory(userId, {
        page,
        limit,
      });

      if (response.data?.success && response.data?.data?.history_entries) {
        setHistory(response.data.data.history_entries || []);
        setPagination(
          response.data.data.pagination || {
            page: 1,
            limit: 50,
            total: 0,
            totalPages: 1,
          },
        );
      } else {
        throw new Error('Failed to fetch user history');
      }
    } catch (err) {
      console.error('Error fetching user history:', err);
      setError(
        err.response?.data?.message ||
          err.message ||
          'Failed to fetch user history',
      );
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch && userId) {
      fetchUserHistory();
    }
  }, [userId, autoFetch]);

  return {
    history,
    pagination,
    loading,
    error,
    refetch: fetchUserHistory,
  };
};
